import {Drawer, List, ListItemText, ListItemIcon, Box, useMediaQuery, ListItemButton, Typography} from '@mui/material';
import React from "react";
import { Link, useLocation } from 'react-router-dom';
import LunchDiningRoundedIcon from '@mui/icons-material/LunchDiningRounded';
import IcecreamRoundedIcon from '@mui/icons-material/IcecreamRounded';
import LocalBarRoundedIcon from '@mui/icons-material/LocalBarRounded';
import SearchIcon from '@mui/icons-material/Search';
import ImageIcon from '@mui/icons-material/Image';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import EditIcon from '@mui/icons-material/Edit';
import { useTheme } from '@mui/material/styles';

const Slidebar_Dashboard = () => {
    const location = useLocation();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const menuItems = [
        { text: 'Comidas', icon: <LunchDiningRoundedIcon />, path: '/dashboard/comidas' },
        { text: 'Helados', icon: <IcecreamRoundedIcon />, path: '/dashboard/helados' },
        { text: 'Bebidas', icon: <LocalBarRoundedIcon />, path: '/dashboard/bebidas' },
        { text: 'Misterio', icon: <SearchIcon />, path: '/dashboard/misterio' },
        { text: 'Clientes', icon: <ImageIcon />, path: '/dashboard/clientes' },
        { text: 'Reto', icon: <EmojiEventsIcon />, path: '/dashboard/cono-gratis' },
        { text: 'Editar', icon: <EditIcon  />, path: '/dashboard/textos' }
    ];

    if (isSmallScreen) {
        return (
            <Box
                component="nav"
                sx={{
                    width: "100%",
                    borderBottom: "2px solid #ccc",
                    backgroundColor: "white",
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: 1,
                    pt: 0
                }}
            >
                {menuItems.map((item) => (
                    <Box
                        key={item.text}
                        component={Link}
                        to={item.path}
                        style={{
                            textDecoration: "none",
                            color:
                                location.pathname === item.path
                                    ? theme.palette.primary.main
                                    : "inherit",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            fontSize: "0.8rem",
                        }}
                    >
                        {item.icon}
                        <Typography variant="caption">{item.text}</Typography>
                    </Box>
                ))}
            </Box>
        );
    }

    return (
        <Drawer
            variant="permanent"
            sx={{
                width: 200,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: 200,
                    boxSizing: 'border-box',
                    backgroundColor: 'white',
                    borderRight: '2px solid #ddd',
                },
            }}
        >
            <List sx={{ pt: 13 }}>
                {menuItems.map((item) => (
                    <ListItemButton
                        key={item.text}
                        component={Link}
                        to={item.path}
                        sx={{
                            color: location.pathname === item.path ? theme.palette.primary.main : "inherit",
                        }}
                    >
                        <ListItemIcon>
                            {React.cloneElement(item.icon, {
                                sx: { color: location.pathname === item.path ? theme.palette.primary.main : "inherit" }
                            })}
                        </ListItemIcon>
                        <ListItemText primary={item.text}
                                      sx={{
                                          color: location.pathname === item.path ? theme.palette.primary.main : "inherit"
                                      }}
                        />
                    </ListItemButton>
                ))}
            </List>
        </Drawer>
    );
};

export default Slidebar_Dashboard;